import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import '../styles/CarrouselServices.css';

const services = [
  { title: 'CONSEIL ET FORMATION', details: 'Préparation technique\nFormation navigation\nAide à la prise en main' },
  { title: 'PRÉPARATION GRANDE CROISIÈRE', details: 'Transformation & Refit\nAluminium / Composite' },
  { title: 'PRÉPARATION COQUE & PONT', details: 'Applicateur META-Grip\nPrimaires et enduits MAP Yachting\nAntidérapant DECKLINE\nLustrage Polish' },
  { title: 'TRAVAUX DE MÉTALLERIE', details: 'Soudure alu / inox\nSoudure & décapage laser\nCréation portique / casquette / bimini' },
  { title: 'GRÉEMENT & VOILES', details: 'Dormant / Courant / Textile\nVoiles\nAccastillage' },
  { title: 'NETTOYAGE & CONCIERGERIE', details: 'Intérieur / Extérieur\nConciergerie\nHivernage / Thermobachage' },
];

const CarrouselServices = () => {
  return (
<div className="carrousel-viewport">
  <div className="carrousel-container">
    <Swiper
      slidesPerView={3}
      centeredSlides={true}
      loop={true}
      spaceBetween={40}
      navigation={true}
      modules={[Navigation]}
      className="swiper-custom"
       breakpoints={{
    0: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    769: {
      slidesPerView: 3,
      centeredSlides: true,
    }
  }}
    >
      {services.map((service, index) => (
        <SwiperSlide key={index} className="service-slide">
          <div className="service-card">
            <h3>{service.title}</h3>
            <p>
              {service.details.split('\n').map((line, i) => (
                <span key={i}>{line}<br /></span>
              ))}
            </p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</div>
  );
};

export default CarrouselServices;
